import { RiskLevel } from "@/model/RiskLevel";
import { NullBanner } from "@/model/DefaultBanners";
import SuffolkLogo from "@/assets/regions/suffolk-logo-blue.svg";
import TurningPointLogo from "@/assets/regions/turning-point-logo-2.png";
export const LowerRisk = {
    rawCopy: "<strong>Keep up the good work</strong> with the help of the " +
        "<u>free&nbsp;DrinkCoach&nbspapp!</u>",
    logoLink: "https://drinkcoach.org.uk/download-drinkcoach-app"
};
const IncreasingRisk = {
    rawCopy: `For Increasing Risk scores we recommend you cut down your drinking. Click here to
        <u>book a free online DrinkCoach Appointment</u>.`,
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/29"
};
const HigherRisk = {
    rawCopy: `For Higher Risk scores we recommend you cut down your drinking. Click here to
        <u>book a free online DrinkCoach Appointment</u>.`,
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/29"
};
const HighRisk = {
    rawCopy: "For alcohol advice and support contact Turning Point ph: 0300 123 0872 or email: suffolk@turning-point.co.uk",
    logoLink: "https://www.turning-point.co.uk/services/suffolk-recovery-network"
};
export default {
    name: "Suffolk",
    logo: {
        file: SuffolkLogo,
        width: 206,
        height: 64
    },
    logoHigh: {
        file: TurningPointLogo,
        width: 332,
        height: 188
    },
    hasFreeAppointments: true,
    zoomLevel: 9,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: NullBanner,
        [RiskLevel.Lower]: LowerRisk,
        [RiskLevel.Increasing]: IncreasingRisk,
        [RiskLevel.Higher]: HigherRisk,
        [RiskLevel.High]: HighRisk
    },
    regions: [
        "Babergh",
        "East Suffolk",
        "Ipswich Borough",
        "Mid Suffolk",
        "West Suffolk",
    ],
    clinics: [
        {
            name: "Suffolk have dedicated alcohol advisors throughout the county. Contact Turning Point for more information and advice",
            isPrimaryProvider: true,
            showAtRiskLevel: [RiskLevel.Higher],
            description: "hide",
        },
        {
            name: "Turning Point",
            description: "Contact ${name}",
            isPrimaryProvider: true,
            phone: ["0300 123 0872"],
            email: "suffolk@turning-point.co.uk",
            website: "https://www.turning-point.co.uk"
        },
        {
            name: "DrinkCoach Online Appointment",
            showAtRiskLevel: [RiskLevel.Increasing, RiskLevel.Higher, RiskLevel.High],
            alwaysShowFirst: true,
            isPrimaryProvider: true,
            tagline: "Free coaching sessions are available for adults aged 18+ in Suffolk. " +
                "Daytime, evening and weekend appointments available. " +
                "<a href='https://drinkcoach.bookinglive.com/' target='_blank'>Click here</a> to book an appointment.",
            alwaysShowInResults: true,
            website: "https://drinkcoach.bookinglive.com/"
        },
        {
            name: "Turning Point",
            location: { lat: 52.2464815, lng: 0.7123766 },
            address: "2 Looms Lane, Bury St Edmunds, Suffolk IP33 1HE",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }],
                    }
                }
            ],
            phone: ["0300 303 8677"],
            email: "suffolk@turning-point.co.uk",
            website: "https://turning-point.co.uk/"
        },
        {
            name: "Turning Point",
            location: { lat: 52.0570985, lng: 1.1482534 },
            address: "Sanderson House, 17 – 19 Museum Street, Ipswich, Suffolk IP1 1HE",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }],
                    }
                }
            ],
            phone: ["0300 303 8677"],
            email: "suffolk@turning-point.co.uk",
            website: "https://turning-point.co.uk/"
        },
        {
            name: "Turning Point",
            location: { lat: 52.4703046, lng: 1.7415464 },
            address: "Woodbury House, Mill Road, Lowestoft, Suffolk NR33 0PP",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }],
                    }
                }
            ],
            phone: ["0300 303 8677"],
            email: "suffolk@turning-point.co.uk",
            website: "https://turning-point.co.uk/"
        },
    ]
};
//# sourceMappingURL=Suffolk.js.map